import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem } from "../../utils/data";
import { OptionalServiceType } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";

export const fetchOptionalServices = createAsyncThunk("get/OptionalServiceDetails", async ({ placeId,userId }: { placeId: number|string,userId:string }) => {
    const data = await fetchData(`OptionalService/getOptionalServiceWithPlaceId?placeId=${placeId}&userId=${userId}&lang=${lang}`,true);
    return data;
});
export const fetchOptionalServiceAdmin = createAsyncThunk("get/getOptionalServiceWithAllData", async (id:number) => {
        const data = await fetchData(`OptionalService/getOptionalServiceWithAllData?serviceId=${id}`,true);
        return data;
});
export const addOptionalService = createAsyncThunk("post/OptionalService", async (OptionalServiceData: any) => {
       const res= await handleAddItem(OptionalServiceData, "OptionalService/addOptionalService", "POST");
        return res;
});

export const deleteOptionalService = createAsyncThunk("delete/OptionalService", async (id: number) => {
        await deleteItem(`OptionalService/deleteOptionalService?serviceId=`,id);
        return id;
});
export const deleteOptionalServiceFromPlace = createAsyncThunk("delete/OptionalServiceFromPlace", async ({placeId,id}:{placeId:number,id: number}) => {
        await deleteItem(`OptionalService/deleteOptionalService?serviceId=`,id);
        return id;
});
interface OptionalServiceState {
    OptionalServices: OptionalServiceType[];
    OptionalService: OptionalServiceType | null;
    loading: boolean;
    error: string;
}

const initialState: OptionalServiceState = {
    OptionalServices: [],
    OptionalService: null,
    loading: false,
    error: ""
};

const OptionalServiceSlice = createSlice({
    name: "OptionalServiceSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchOptionalServices.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchOptionalServices.fulfilled, (state, action) => {
                state.loading = false;
                state.OptionalServices = action.payload;
            })
            // Fetch article data for admin 
            .addCase(fetchOptionalServiceAdmin.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchOptionalServiceAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.OptionalService = action.payload;
            })

            // Add
            .addCase(addOptionalService.fulfilled, (state, action) => {
                state.OptionalServices.push(action.payload.data);
            })

           
            // Delete
            .addCase(deleteOptionalService.fulfilled, (state, action) => {
                state.OptionalServices = state.OptionalServices.filter((item) => item.id !== action.payload);
            })
    }
});

export default OptionalServiceSlice.reducer;
